<div class="wrapper-commnet" [attr.id]="comment.commentId">
    <div class="wrapper-title">
        <p [textContent]="comment.commentAuthor"></p>
        <div class="wrapper-like-dislike">
            <span class="icon-like">
                <navaar-like-icon
                    (onClick)="clickedlike()"
                    [is-like-from-user]="isliked"
                ></navaar-like-icon>
                <span
                    [textContent]="likesCount"
                    [class.isLike]="isliked"
                ></span>
            </span>
            <span class="icon-dislike">
                <navaar-dis-like-icon
                    (onClick)="clickedDislike()"
                    [is-dislike-from-user]="isDisliked"
                ></navaar-dis-like-icon>
                <span
                    [textContent]="dislikesCount"
                    [class.disLike]="isDisliked"
                ></span>
            </span>
        </div>
    </div>
    <div class="wrapper-rate">
        <div *ngIf="comment.rate != null">
            <navaar-star-icon
                [rate-item]="comment.rate | number"
                [style]="{ width: '8px', height: '6px' }"
            ></navaar-star-icon>
        </div>
        <span [textContent]="comment.commentDate | shamsiDate: 'jYYYY/jMM/jDD'"></span>
    </div>
    <div class="wrapper-description">
        <p
            [@more_desc]="moreTextDesc"
            [textContent]="comment.commentText"
        ></p>
        <span
            class="more-text-style"
            *ngIf="(comment.commentText.length > 170) && !moreTextDesc"
            (click)="moreText()"
        >
            ادامه مطلب... {{ comment.replies?.length ? comment.replies.length : '' }}
        </span>
    </div>
    <div
        class="wrapper-replies"
        *ngIf="comment.replies?.length > 0"
    >
        <ng-template
            ngFor
            [ngForOf]="comment.replies"
            let-replyItem
            let-idx="index"
        >
            <div class="wrapper-title">
                <p [textContent]="replyItem.commentAuthor"></p>
            </div>
            <div class="wrapper-rate">
                <span [textContent]="replyItem.commentDate | shamsiDate: 'jYYYY/jMM/jDD'"></span>
            </div>
            <div class="wrapper-description">
                <p
                    [ngClass]="{
            'more-text': isActive[idx],
            'deactive-more-text': !isActive[idx]
          }"
                    [textContent]="replyItem.commentText"
                ></p>
                <span
                    class="more-text-style"
                    *ngIf="replyItem.commentText.length > 170"
                    (click)="setActiveMoreTextReplies(idx)"
                >
                    ادامه مطلب...
                </span>
            </div>
        </ng-template>
    </div>
</div>
